import { render, staticRenderFns } from "./img-preview.vue?vue&type=template&id=a8fedfcc&"
import script from "./img-preview.vue?vue&type=script&lang=js&"
export * from "./img-preview.vue?vue&type=script&lang=js&"
import style0 from "./img-preview.vue?vue&type=style&index=0&id=a8fedfcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports